<template>
    <div
        class="delete-modal"
    >
        <modal
            :show="true"
            modal-classes="modal-secondary"
            :data-cy="'deleteModal'"
            @close="$emit('close-modal')"
        >
            <template slot="header">
                <h1>{{ $t("pages.fiscalDocument.deletePaymentTitle") }}</h1>
            </template>

            <p>
                {{ $t("pages.fiscalDocument.deletePaymentMessage", {number: fiscalDocumentNumber}) }}
            </p>
            <p>
                {{ $t("modalMessages.unrecoverableOperationMessage") }}
            </p>

            <template slot="footer">
                <base-button
                    type="submit"
                    class="btn btn-danger"
                    :loading="loading"
                    :data-cy="'buttonDeleteConfirm'"
                    @click="deletePayment"
                >
                    {{ $t("actions.delete") }}
                </base-button>
                <base-button
                    type="button"
                    class="btn btn-neutral"
                    :data-cy="'buttonDeleteStop'"
                    @click="$emit('close-modal')"
                >
                    {{ $t("actions.cancel") }}
                </base-button>
            </template>
        </modal>
    </div>
</template>

<script>
import { fiscalDocumentClient } from "@/clients/fiscalDocumentClient";
import exceptionsMixins from "@/mixins/exceptionsMixins";

export default {
    name: 'DeletePayment',
    mixins: [
        exceptionsMixins
    ],
    props: {
        fiscalDocumentId: {
            type: Number,
        },
        fiscalDocumentNumber: {
            type: String
        },
        paymentId: {
            type: Number,
        }
    },
    data() {
        return {
            loading: false,
        };
    },
    methods: {
        deletePayment() {
            this.loading = true;
            fiscalDocumentClient.deletePayment(this.fiscalDocumentId, this.paymentId).then(() => {
                this.$notify({
                    type: "success",
                    icon: "ni ni-notification-70",
                    message: this.$t("notifications.success.deleted")
                });
                this.$emit('data-changed');
            }).catch((error) => {
                this.manageException(error.response);
            }).then(() => {
                this.loading = false;
                this.$emit('close-modal');
            });
        },
    }
}
</script>
